import React from 'react';

import {observer} from 'mobx-react';
import CircularProgress from '@mui/material/CircularProgress';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import {useStores} from '../../../Hooks';

const UnsavedBadge = ({label}) => (
    <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-menu text-xs font-medium whitespace-nowrap"
        style={{backgroundColor: 'color-mix(in srgb, var(--caution-warning-color) 12%, transparent)', color: 'var(--caution-warning-color)'}}
    >
        <InfoOutlinedIcon style={{fontSize: 13}} />
        {label}
    </span>
);

const formatSummary = (summary, generalStore) => {
    if (!summary) return '';
    const parts = [];
    if (summary.projects > 0) parts.push(`${summary.projects} ${generalStore.translate(summary.projects === 1 ? 'project' : 'projects') || (summary.projects === 1 ? 'project' : 'projects')}`);
    if (summary.folders > 0) parts.push(`${summary.folders} ${generalStore.translate(summary.folders === 1 ? 'folder' : 'folders') || (summary.folders === 1 ? 'folder' : 'folders')}`);
    if (summary.items > 0) parts.push(`${summary.items} ${generalStore.translate(summary.items === 1 ? 'item' : 'items') || (summary.items === 1 ? 'item' : 'items')}`);
    return parts.join(', ');
};

const AccessFooter = observer(({summary, onCancel, onSave, isSaving, saveLabel, showSummary = true, hasEdits = false, disableSave = false}) => {
    const {generalStore} = useStores();
    const summaryText = formatSummary(summary, generalStore);
    return (
        <div className="flex items-center justify-between px-4 py-2.5 border-t border-panels-normal">
            <div className="flex items-center min-h-[24px]">
                {showSummary ? (
                    <span className="text-sm text-main-light">{summaryText || (generalStore.translate('noAccess') || 'No access')}</span>
                ) : hasEdits ? (
                    <UnsavedBadge label={generalStore.translate('unsavedChanges') || 'Unsaved changes'} />
                ) : null}
            </div>
            <div className="flex items-center gap-2">
                <button
                    data-testid="access-cancel-button"
                    className="px-4 py-1.5 text-sm text-main-normal rounded-button hover:bg-panels-normal"
                    onClick={onCancel}
                    disabled={isSaving}
                >
                    {generalStore.translate('cancel') || 'Cancel'}
                </button>
                <button
                    data-testid="access-save-button"
                    className="px-4 py-1.5 text-sm text-white rounded-button bg-classic-button-normal hover:bg-classic-button-hover disabled:opacity-50"
                    onClick={onSave}
                    disabled={isSaving || disableSave}
                >
                    {isSaving
                        ? <CircularProgress size={14} style={{color: 'white'}} />
                        : (saveLabel || generalStore.translate('save') || 'Save')
                    }
                </button>
            </div>
        </div>
    );
});

export default AccessFooter;
